import { useCallback, useEffect, useRef } from 'react'

// The tooltip is drawn outside the chart, in a container of its own on the page body -- it has to
// be, or the controls header above the chart paints over it. Highcharts creates that container on
// the first hover and then keeps it for the chart's whole life: hiding the tooltip fades the label
// and leaves the container standing, so a report of fifty questions ends up carrying fifty empty
// containers around, one per chart the reader has passed over.
//
// Tearing the tooltip down gives the container back. Nothing is lost by it: the next hover builds
// both again on demand, which is how the first one arrived.

// Long enough to let the hide that the pointer's departure starts finish first -- tearing down
// mid-fade drops the tooltip on screen rather than fading it. Comfortably over the configured
// hide delay, and unnoticeable to a reader who has already left the chart.
const SETTLE_MS = 400

export const useTooltipTeardown = chartRef => {
  const timer = useRef(null)

  const cancel = useCallback(() => {
    if (timer.current) window.clearTimeout(timer.current)
    timer.current = null
  }, [])

  const teardown = useCallback(() => {
    cancel()
    timer.current = window.setTimeout(() => {
      timer.current = null
      const tooltip = chartRef.current?.chart?.tooltip
      // a tooltip still on screen means the pointer came back to a point rather than to the frame
      if (tooltip && false !== tooltip.isHidden) tooltip.destroy()
    }, SETTLE_MS)
  }, [cancel, chartRef])

  useEffect(() => cancel, [cancel])

  return { onMouseLeave: teardown, onMouseEnter: cancel }
}
